import ListaOpcionSorteo from "./ListaOpcionSorteo";
import Usuario from "./Usuario";

const Schemas = {
    usuario: Usuario,
    listaOpcionSorteo: ListaOpcionSorteo,
};

export default Schemas;
